import { cn } from "@/lib/utils";
import type { FileRoutesByFullPath } from "@/routeTree.gen";
import { Button } from "@st-marketplace/ui";

interface MenuItemProps {
	item: MenuItemType;
	isActive: boolean;
	onClick: () => void;
}

type AllPaths = keyof FileRoutesByFullPath;

interface MenuItemType {
	name: string;
	icon: React.ReactNode;
	route: AllPaths;
	/** Shown at the end of the row, e.g. a count that needs attention. */
	badge?: React.ReactNode;
}

const MenuItem = ({ item, isActive, onClick }: MenuItemProps) => (
	<Button
		className={cn(
			"w-full justify-start whitespace-nowrap",
			isActive && "border border-primary",
		)}
		variant="text"
		size="lg"
		color={isActive ? "primary" : "ghost"}
		onClick={onClick}
		startIcon={item.icon}
	>
		{item.name}
		{item.badge ? <span className="ms-auto">{item.badge}</span> : null}
	</Button>
);

export default MenuItem;

export type { MenuItemType };
